import { updateField } from 'vuex-map-fields';
export default {
    updateField,
    first_name(state, payload) {
        state.first_name = payload;
    },
    last_name(state, payload) {
        state.last_name = payload;
    },
    email(state, payload) {
        state.email = payload;
    },
    password(state, payload) {
        state.password = payload;
    },
    password_confirmation(state, payload) {
        state.password_confirmation = payload;
    },
    current_password(state, payload) {
        state.current_password = payload;
    },
    passwordConfirmed(state, payload) {
        state.passwordConfirmed = payload;
    },
    salutation(state, payload) {
        state.salutation = payload;
    },
    firstName(state, payload) {
        state.first_name = payload;
    },
    lastName(state, payload) {
        state.last_name = payload;
    },
    language(state, payload) {
        state.language = payload;
    },
    togglePassword(state) {
        state.pwordHidden = !state.pwordHidden;
    },
    togglePasswordConfirmation(state) {
        state.pwordConfirmHidden = !state.pwordConfirmHidden;
    },
    toggleCurrentPassword(state) {
        state.currentPwordHidden = !state.currentPwordHidden;
    },
    remember_me(state) {
        state.remember_me = !state.remember_me;
    },
    accepted_terms(state) {
        state.accepted_terms = !state.accepted_terms;
    },
    over_18(state) {
        state.over_18 = !state.over_18;
    },
    setDateOfBirth(state, payload) {
        state.date_of_birth = payload;
    },
    passwordValidated(state, payload) {
        state.passwordValidated = payload;
    },
    passwordSubmitFailed(state, payload) {
        state.passwordSubmitFailed = payload;
    },
    hasUserNow(state, payload) {
        state.hasUser = payload;
    },
    setAffiliate(state, payload) {
        state.affiliate = payload;
    },
    setSalutations(state, payload) {
        state.allowedSalutations = { ...state.allowedSalutations, ...payload };
    },
    callbackUrl(state, url) {
        state.callbackUrl = url;
    },
    goToSmartCharts(state, shouldGo) {
        state.go_to_smartcharts = shouldGo;
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Auth/mutations.js